import { z } from 'zod'

const dateString = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date must be YYYY-MM-DD')

export const systemAnnouncementFormSchema = z
  .object({
    announcement_topic: z.string().min(1, 'Topic is required'),
    announcement_description: z.string().min(1, 'Description is required'),
    start_date: dateString,
    end_date: dateString,
    show_effective_dates: z.boolean(),
    fk_org_id: z.string(),
    roles: z.array(z.string()),
  })
  .refine((v) => v.end_date >= v.start_date, {
    message: 'End date must be on or after start date',
    path: ['end_date'],
  })

export type SystemAnnouncementFormValues = z.infer<typeof systemAnnouncementFormSchema>
